module.exports = __webpack_public_path__ + "img/ant.3d32aa8a.jpg";